import(/* webpackMode: "eager" */ "/codebuild/output/src2264119988/src/app/home/page.tsx");
